// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36153719","488":"9d5d80d5","553":"78c51614","977":"c348261b"}[chunkId] + ".chunk.js";
};